import noop from 'lodash/noop';
import ReplayIcon from '@mui/icons-material/Replay';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';

type Props = {
    title: string;
    subtitle?: string;
    buttonLabel?: string;
    onButtonClick?: () => void;
};

export const ApiError: React.FC<Props> = (props) => {
    return (
        <div className='flex flex-col h-[500px] items-center justify-center'>
            <img src='/alert.png' alt='Error' style={{height: 100, width: 100, margin: 10}} />
            <Typography sx={{textAlign: 'center'}}>{props.title}</Typography>
            {props.subtitle ? (
                <Typography color='GrayText' sx={{textAlign: 'center'}}>
                    Code: {props.subtitle}
                </Typography>
            ) : null}
            <Button variant='outlined' sx={{m: 3}} endIcon={<ReplayIcon />} onClick={props.onButtonClick ?? noop}>
                {props.buttonLabel ?? 'Try Again'}
            </Button>
        </div>
    );
};
